import { OverflowButton } from './Styled';
import type { OverflowPageButtonProps } from './types';

const OVERFLOW_TEXT = '...';

/**
 * OverflowPageButton
 *
 * The button that's used to display the '...' if more pages exist than are visible
 * in the pagination.
 *
 * Right now, this is not actually a button but a div. This may eventually change if the
 * this component gets the functionality for the user to select a non-visible page to view,
 * which is why it is aptly named "button".
 * */
export const OverflowPageButton = ({
  pageVariant,
  overflowText = OVERFLOW_TEXT,
  ...props
}: OverflowPageButtonProps) => (
  <OverflowButton $pageVariant={pageVariant} {...props}>
    {overflowText}
  </OverflowButton>
);
